'use strict';

const {
  app
} = window;
module.exports.URL = function (CODE) {
  var _route$front;
  const route = (app.state.session.routes || []).find(data => data.CODE === CODE) || {};
  if (!(route !== null && route !== void 0 && (_route$front = route.front) !== null && _route$front !== void 0 && _route$front.url)) {
    return CODE;
  }
  return route.front.url;
};
module.exports.action = function (CODE) {
  let route = (app.state.session.routes || []).find(route => route.CODE === CODE);
  if (!route) {
    return CODE;
  }
  return route.back.url.slice(route.back.url.indexOf('/'));
};
